const style = {
  changePasswordForm__errorMessage: {
    fontSize: '12px',
    display: 'block',
    marginBottom: '13px',
  },
};

export default style;
